(() => {
  const BRANDING_LINK_SELECTOR = [
    'a[href*="apps.shopify.com/eu-widerrufsbutton"]',
    'a[href*="consumer-withdrawal.eu"]',
    'a[href*="apps.shopify.com/eu-withdrawal"]',
  ].join(', ');

  const BRANDING_ROOT_SELECTOR = [
    '.widerruf-form-branding',
    '.widerruf-form-branding__link',
  ].join(', ');

  const hideNode = (node) => {
    if (!node || node.classList?.contains('noju-withdrawal-branding-hidden')) return;

    node.classList.add('noju-withdrawal-branding-hidden');
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
    node.style.setProperty('height', '0', 'important');
    node.style.setProperty('max-height', '0', 'important');
    node.style.setProperty('overflow', 'hidden', 'important');
    node.style.setProperty('margin', '0', 'important');
    node.style.setProperty('padding', '0', 'important');
    node.style.setProperty('opacity', '0', 'important');
    node.style.setProperty('pointer-events', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
  };

  const hideBranding = (root = document) => {
    root.querySelectorAll(BRANDING_ROOT_SELECTOR).forEach(hideNode);

    root.querySelectorAll(BRANDING_LINK_SELECTOR).forEach((link) => {
      const wrapper =
        link.closest('.widerruf-form-branding') ||
        link.closest('div[style*="justify-content"]') ||
        link.parentElement;

      hideNode(link);
      if (wrapper) hideNode(wrapper);
    });

    root.querySelectorAll('a, button, span').forEach((element) => {
      if (element.closest('form')) return;

      const text = element.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;

      if (
        /learn more.*withdrawal/i.test(text) ||
        /^eu withdrawal button$/i.test(text) ||
        /powered by revoq/i.test(text) ||
        /^eu withdrawal process$/i.test(text)
      ) {
        const wrapper =
          element.closest('.widerruf-form-branding') ||
          element.closest('div[style*="justify-content"]') ||
          element;

        hideNode(wrapper);
      }
    });
  };

  hideBranding();

  const observer = new MutationObserver(() => hideBranding());
  observer.observe(document.body, { childList: true, subtree: true });

  window.setTimeout(hideBranding, 250);
  window.setTimeout(hideBranding, 1000);
  window.setTimeout(hideBranding, 3000);
})();